module.exports = __webpack_public_path__ + "static/mobile-steps-01c682a6a80bcdec8a03ef50b9fb7ef9.png";